import PropTypes from 'prop-types';
import { BOTPRESS_ACTIONS } from '../../hooks/useBotpress/useBotpress.constants';
import { BOTPRESS_EVENT_TYPES } from '../../services/eventGenerators';
var EventActionDataType = PropTypes.shape({
  eventType: PropTypes.oneOf(BOTPRESS_EVENT_TYPES),
  eventData: PropTypes.shape({})
});
var OpenChatActionType = PropTypes.shape({
  type: PropTypes.oneOf([BOTPRESS_ACTIONS.OPEN_CHAT]).isRequired
});
var SendMessageActionType = PropTypes.shape({
  type: PropTypes.oneOf([BOTPRESS_ACTIONS.SEND_MESSAGE]).isRequired,
  payload: PropTypes.string.isRequired
});
var SendEventActionType = PropTypes.shape({
  type: PropTypes.oneOf([BOTPRESS_ACTIONS.SEND_EVENT]).isRequired,
  payload: EventActionDataType
});
export var ActionPropType = PropTypes.oneOfType([OpenChatActionType, SendMessageActionType, SendEventActionType]);
export var ActionsPropType = PropTypes.arrayOf(ActionPropType);